// extracted by mini-css-extract-plugin
export default {"ToggleFullscreenButton":"ujgHZ","buttonPositioning":"Djnvz","buttonAspect":"JVGYN"};